import React from "react";

function ScheduleCard({ match, index }) {
    const formatTime = (startTime) => {
        if (!startTime) return "--:--";
        const date = new Date(startTime);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="sched-card">
            <div className="sched-time-blk">
                <div className="st-label">{index === 0 ? "Next" : "Today"}</div>
                <div className="st-time">{formatTime(match.matchStartTime)}</div>
                <div className="st-date">Today</div>
            </div>
            <div className="sched-main">
                <div className="sched-teams">
                    {match.team1Name || "TBD"}
                    <span className="sched-vs">vs</span>
                    {match.team2Name || "TBD"}
                </div>
                <div className="sched-venue">
                    Virtual IPL · {match.matchId}
                </div>
            </div>
            <div className="sched-right">
                <div className="fmt-chip">VIRTUAL</div>
            </div>
        </div>
    );
}

export default ScheduleCard;